import { render, staticRenderFns } from "./detail-receipt-plan.vue?vue&type=template&id=7db48648"
import script from "./detail-receipt-plan.vue?vue&type=script&lang=js"
export * from "./detail-receipt-plan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports